import { Pipe, PipeTransform } from "@angular/core";
import {TranslocoService} from "@ngneat/transloco";

const PADDING = "000000";

@Pipe({ name: "myCurrency" })
export class CurrencyPipe implements PipeTransform {

  private DOT_SEPARATOR = ".";
  private COMMA_SEPARATOR = ",";

  constructor(private transloco: TranslocoService) {
  }

  transform = (value: number | string | undefined, currencyLabel = "", fractionSize = 2): string => {
    const decimalSeparator = this.transloco.getActiveLang() === "en" ? this.DOT_SEPARATOR : this.COMMA_SEPARATOR;
    const thousandsSeparator = this.transloco.getActiveLang() === "en" ? this.COMMA_SEPARATOR : this.DOT_SEPARATOR;
    if (value || value === 0) {
      let [integer, fraction = ""] = value.toString().split(this.DOT_SEPARATOR);

      fraction = fractionSize > 0
        ? decimalSeparator + (fraction + PADDING).substring(0, fractionSize)
        : "";

      integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);

      return `${integer}${fraction} ${currencyLabel}`;
    } else {
      return "-";
    }
  }
}
